<section class='mb-5'>
 <div class='container-fluid p-4' [id]='"bannesNosotros"'>
  <div class='row'>
   <div class='col-lg-6 ps-lg-5'>
    <h1 class='txtBold'>Segurnet, una nueva visión de seguros</h1>
   </div>
  </div>
 </div>

 <div class='container mt-5 px-4 px-lg-5' [id]='"segHistory"'>
  <h3 class='txtBold'>¿Quiénes somos?</h3>
  <p>Segurnet es una empresa de corretaje de seguros y reaseguros que abrió sus puertas en el 2006, con alta vocación de servicio y experiencia en el mercado asegurador. Clasificados entre las 10 mejores firmas de corretaje en el país, en términos de volumen e ingresos netos, con una estructura que combina la experiencia, el conocimiento, la disposición y la innovación para asegurar la calidad del servicio.</p>
  <p>Nos hemos destacado por diseñar e implementar soluciones de seguros a la medida, así como, por aprovechar nuevos canales de comercialización para la colocación masiva de seguros e innovar en la estrategia de banca seguros, apoyados en programas tecnológicos especializados y desarrollados por nuestro equipo técnico.</p>
  <p>Nuestra satisfacción es que nuestros clientes estén adecuadamente protegidos, desarrollando propuestas personalizadas con la más alta calidad de servicios, obteniendo para ellos las coberturas más amplias, al más justo precio.</p>
 </div>
</section>

<!-- Valores y mision -->
<section class='container-fluid bgGris d-flex justify-content-center'>


 <div class='container row pt-5 mb-lg-4 pb-0 px-3 px-lg-5 mx-0'>
  
   <div class='col-12 col-lg-4 d-flex flex-column justify-content-center'>
    <img src='assets/img/mision.png' alt='imagen de la mision Segurnet' class='mx-auto' loading='lazy'>
    <p class='txtBold text-center mt-3 mb-0'>Misión</p>
    <p class='text-center text-lg-start'>Proveer a nuestros clientes <span class='txtSegu txtBold'>la asesoría más completa</span> en materia de seguros, diseñando y obteniendo para ellos las coberturas más ajustadas a sus necesidades de protección, al más justo precio; proporcionándole además una  <span class='txtSegu txtBold'>eficiente plataforma de servicios para satisfacer sus necesidades</span> de información y soporte en la administración de sus programas de seguros.</p>
   </div>

   <div class='col-12 col-lg-4 mt-3 d-flex flex-column justify-content-center'>
    <img src='assets/img/vision.png' alt='imagen de la vision Segurnet' class='mx-auto' loading='lazy'>
    <p class='txtBold text-center mt-3 mb-0'>Visión</p>
    <p class='text-center'>Ser la mejor y <span class='txtSegu txtBold'>más innovadora opción en el corretaje de seguros</span> de nuestro país, a través de ideas, productos y soluciones que marquen tendencias en el mercado asegurador dominicano, proporcionando a nuestros clientes el mayor valor agregado a través de nuestro servicio.</p>
   </div>

   <div class='col-12 col-lg-4 mt-3 d-flex flex-column justify-content-center'>
    <img src='assets/img/valores.png' alt='imagen de la valores Segurnet' class='mx-auto' loading='lazy'>
    <p class='txtBold text-center mt-3 mb-0'>Valores</p>
    <p class='text-center mb-lg-5'>Integridad<br>Innovación<br>Equipo<br>Servicio<br><br><br></p>
   </div>
 </div>

</section>

<!-- Segurnet somo -->

<section class='container my-5 d-flex flex-column justify-content-center'>
  <h3 class='txtBold text-center text-lg-start mb-4'>En Segurnet somos</h3>
  <span [id]='"lineSeg"'></span>

  <div class='row mt-4 my-lg-5'>

   <div class='col-12 col-lg-3 px-5'>
    <p class='mb-2 text-uppercase txtBold text-center text-lg-start'>Integridad</p>
    <p class='text-center text-lg-start'>Servimos al cliente <span class='txtSegu txtBold'>adheridos a nuestros principios morales</span>, construimos relaciones profesionales de confianza y respeto</p>
   </div>

   <div class='col-12 col-lg-3 mt-2 px-5'>
    <p class='mb-2 text-uppercase txtBold text-center text-lg-start'>Innovación</p>
    <p class='text-center text-lg-start'>En constante búsqueda por encontrar <span class='txtSegu txtBold'>nuevas y mejores formas</span> de sobrepasar las expectativas de nuestros clientes.</p>
   </div>

   <div class='col-12 col-lg-3 mt-2 px-5'>
    <p class='mb-2 text-uppercase txtBold text-center text-lg-start'>Equipo</p>
    <p class='text-center text-lg-start'>Alineamos nuestros esfuerzos hacia <span class='txtSegu txtBold'>un mismo objetivo: la satisfacción de nuestros clientes</span>.
    </p>
   </div>

   <div class='col-12 col-lg-3 mt-2 px-5'>
    <p class='mb-2 text-uppercase txtBold text-center text-lg-start'>Accesibles</p>
    <p class='text-center text-lg-start'>Disponibles para nuestros clientes las <span class='txtSegu txtBold'>24 horas del día, todos los días</span> de la semana.</p>
   </div>
  </div>
  <div class='d-flex justify-content-end justify-content-lg-start'>
   <span [id]='"lineSegDown"'></span>
  </div>
  
</section>


<!-- Reconocimientos -->

<section class='container mb-5'>
  <div class='mb-4'>
   <h3 class='txtBold text-center'>Reconocimientos más recientes</h3>
 </div>

 <div class='row mt-md-4 mt-lg-5'>
  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'><img src='assets/img/certificado.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Atrio Seguros, Segundo lugar 2020 en top líderes en producción 2020</p></div>
  </div>

  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'><img src='assets/img/destacadoMer.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Galardonados como una de las empresas más admiradas del 2020 en el sector “Corredores de Seguros” por la @revistamercado. Revista Mercado (2017,2018,2019,2020)</p></div>
  </div>

  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'><img src='assets/img/40un40.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Nuestro Vicepresidente Ejecutivo, Alejandro Campos, es reconocido en el importante ranking #40under40 2020 de la @revistamercado, resaltando su exitosa trayectoria, visión de negocios y trabajo incansable.</p></div>
  </div>

  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'><img src='assets/img/roble2020.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Ganadores del 3er. Lugar en la categoría Roble 2020 de Seguros Reservas.</p></div>
  </div>

  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'> <img src='assets/img/trebol2020.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Ganadores del 1er. Lugar de la categoría C1 del Programa Trebol en el 2020 de MAPFRE BHD.</p></div>
  </div>

  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'><img src='assets/img/roble.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Ganadores del 1er. Lugar en la categoría Roble 2018 de Seguros Reservas.</p></div>   
  </div>

  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'><img src='assets/img/certificado.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Humano Seguros, Corredor Líder Marzo Mayo 2019 Salud Internacional.</p></div>
  </div>

  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'><img src='assets/img/destacados2019.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Humano Seguros, Corredor Destacado 2019 Seguros Generales.</p></div>
  </div>

  <div class='col-12 col-md-6 col-lg-4 row'>
    <div class='col-3'><img src='assets/img/bansSeg2016.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Humano Seguros, Mayor Producción Banca Seguros 2016 y 2017.</p></div>
  </div>
  
  <div class='col-12 col-md-6 col-lg-4 pt-lg-1 row'>
    <div class='col-3'><img src='assets/img/carteGobal2017.png' alt='Reconocimientos Segurnet' loading='lazy'></div>
    <div class='col-9'><p>Angloamericana, Mayor Productor Cartera Global 2017.</p></div>
  </div>
 </div>
</section>